var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 38,
    viewBox: "0 0 52 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5C1.61929 16.5 0.5 17.6193 0.5 19C0.5 20.3807 1.61929 21.5 3 21.5V16.5ZM50.7678 20.7678C51.7441 19.7915 51.7441 18.2085 50.7678 17.2322L34.8579 1.32233C33.8816 0.34602 32.2986 0.34602 31.3223 1.32233C30.346 2.29864 30.346 3.88155 31.3223 4.85786L45.4645 19L31.3223 33.1421C30.346 34.1184 30.346 35.7014 31.3223 36.6777C32.2986 37.654 33.8816 37.654 34.8579 36.6777L50.7678 20.7678ZM3 21.5H49V16.5H3V21.5Z",
    fill: "url(#paint0_linear_1336_2776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1336_2776",
    x1: 3,
    y1: 19.5,
    x2: 49,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#613D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AE6B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF9365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesArrow);
export default __webpack_public_path__ + "static/media/resources_arrow.791cb0e4e19b02d580ba8ef8222ed40d.svg";
export { ForwardRef as ReactComponent };